// 中文繁体
export default {
    title: {
        homeTitle: "慧悅財經-財經公關_港股_上市公司_PR_公關易",
        courseTitle: "港股課程",
        courseDetailTitle: "課程詳情",
        teacherTitle: "慧悅講師",
        rentTitle: "場地租用",
        topTitle: "「股你唔到」排行榜",
        teacherDetailTitle: "講師詳情",
        newsDetailTitle: "資訊詳情",
        newsTitle: "資訊在線",
        myCourseTitle: "我的課程",
        myOrderTitle: "我的訂單",
        couponsTitle: "優惠券",
        userCenterTitle: "個人中心",
        playerTitle: "視頻播放",
        aboutUs: "關於我們",
        contact: "聯繫方式",
        agreement: "用戶協議",
        statement: "免責聲明",
        comfireOrderTitle: "購買課程"
    },
    tabBar: {
        index: "首頁",
        course: "港股課程",
        teacher: "慧悅講師",
        rent: "場地租用",
        top: "股你唔到",
        information: "資訊在線",
        column: "慧悅專欄",
        1: "個人中心",
        2: "我的課程",
        3: "我的訂單",
        4: "優惠券",
        5: "退出登錄",
        6: "下載",
        7: "登錄",
        8: "註冊",
        9: "搜索您感興趣的課程"
    },
    header: {
        pr: "慧悅財經公關"
    },
    footer: {
        aboutUs: "關於我們",
        contact: "聯繫方式",
        agreement: "用戶協議",
        statement: "免責聲明",
        weChat: "官方微信",
        myCourse: "我的課程",
        1: "慧悅財經"
    },
    home: {
        teacherList: "專家級講師",
        more: "更多",
        column: "慧悅專欄",
        course: "精選課程",
        liveList: "交易日直播時間表",
        hoster: "主持人：",
        newsOnline: "慧悅獨家資訊"
    },
    news: {
        1: "推薦資訊",
        2: "閱讀"
    },
    course: {
        new: "最新",
        hot: "最熱",
        price: "價格",
        1: "學"
    },
    teacher: {
        integration: "綜合",
        hot: "最熱",
        new: "最新",
        1: "老師簡介",
        2: "老師課程"
    },
    userCenter: {
        1: "個人資料",
        2: "修改密碼",
        3: "用戶名",
        4: "手機號",
        5: "郵箱",
        6: "性別",
        7: "個人簡介",
        8: "舊密碼:",
        9: "新密碼:",
        10: "確認密碼:",
        11: "請輸入用戶名",
        12: "修改綁定",
        13: "請填寫郵箱地址",
        14: "請輸入您的個人信息",
        15: "確認",
        16: "請輸入舊密碼",
        17: "請輸入新密碼",
        18: "請重新輸入新密碼",
        19: "請輸入密碼",
        20: "請再次輸入密碼",
        21: "兩次輸入密碼不一致",
        22: "請輸入正確的郵箱地址"
    },
    coupons: {
        1: "優惠券",
        2: "老用戶",
        3: "滿",
        4: "可使用",
        5: "有效期",
        6: "新用戶",
        7: "體驗",
        8: "活動回贈",
        9: "推薦奬勵"
    },
    myOrder: {
        1: "訂單管理",
        2: "訂單號",
        3: "取消訂單",
        4: "刪除",
        5: " 全選",
        6: "確定",
        7: "確認",
        8: "訂單",
        9: "之後將無法恢複, 是否繼續?",
        10: "您尚未選中任何訂單!",
        11: "銀行轉賬",
        12: "支付寶"
    },
    myCourse: {
        1: "已購課程",
        2: "我的收藏",
        3: "已學習",
        4: "繼續學習",
        5: "評價",
        6: "查看評價",
        7: "條紀錄",
        8: "評分",
        9: ["較差", "一般", "尚可", "滿意", "驚喜"],
        10: "請輸入評價，200字以內！"
    },
    login: {
        1: "手機登錄",
        2: "手機註冊",
        3: "手機找回",
        4: "郵箱登錄",
        5: "郵箱註冊",
        6: "郵箱找回",
        7: "註冊",
        8: "請輸入電話號碼",
        9: "請輸入您的郵箱",
        10: "請輸入驗證碼",
        11: "發送驗證碼",
        12: "重新發送",
        13: "輸入新的密碼",
        14: "請輸入密碼",
        15: "記住密碼",
        16: "忘記密碼",
        17: "登錄",
        18: "確定",
        19: "我已閱讀並同意",
        20: "慧悅港股服務協議",
        21: "已有帳號",
        22: "去登錄",
        23: "電話號碼不能為空",
        24: "電話號碼格式有誤",
        25: "請輸入郵箱地址",
        26: "郵箱格式有誤",
        27: "請輸入密碼",
        28: "密碼長度為6至20位",
        29: "請輸入用戶名",
        30: "沒有賬號"
    },
    courseDetail: {
        1: "港股課程",
        2: "優惠價",
        3: "免費",
        4: "人已購買",
        5: "作者",
        6: "書本介紹",
        7: "書本目錄",
        8: "學員評價",
        9: "繼續閱讀",
        10: "立即購買",
        11: "繼續學習",
        12: "開始閱讀",
        13: "免費試閱",
        14: "作者"
    },
    comfireOrder: {
        1: "用戶名",
        2: "購買課程",
        3: "支付結果",
        4: "課程名稱",
        5: "價格",
        6: "課程價格",
        7: "我的優惠券",
        8: "請選擇優惠券",
        9: "暫無可用優惠券",
        10: "選擇優惠券",
        11: "添加優惠碼",
        12: "請輸入優惠碼",
        13: "溫馨提示：優惠券與優惠碼不可同時使用",
        14: "請選擇支付方式",
        15: "總金額",
        16: "實付金額",
        17: "提交訂單",
        18: "使用微信掃描二維碼進行支付",
        19: "請在支付頁面繼續完成支付",
        20: "重新選擇支付方式",
        21: "失敗",
        22: "去學習"
    },
    popTitle: {
        1: "評分",
        2: "綁定手機號",
        3: "綁定郵箱",
        4: "確 定",
        5: "功能只對APP用戶開放！",
        6: "綁定",
        7: "掃碼下載--慧悅財經APP"
    },
    topRank: {
        1: "日榜",
        2: "周榜",
        3: "月榜",
        4: "我要挑戰",
        5: "競猜",
        6: "規則",
        7: "選擇候選人",
        8: "您競猜候選人",
        9: "支持候選人",
        10: "候選人列表",
        11: "支持人數",
        12: "上期競猜結果",
        13: "競猜成功名單",
        14: "競猜成功",
    },
    challenge: {
        1: "請輸入",
        2: "股票名稱",
        3: "股票代號",
        4: "買入價",
        5: "目標價",
        6: "止蝕價",
        7: "發起挑戰",
        8: "發起挑戰時間",
        9: "投資回報率",
    },
    dataTip: {
        "1": "暫無數據"
    }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_tw.js